export default defineNuxtRouteMiddleware((to, from) => {
  // Ensure auth pages are properly handled when navigating
  const authPaths = ['/auth/forgot-password', '/auth/reset-password']
  
  // Only redirect if not already on the target path
  // and only when coming from a non-auth path to prevent loops
  if (authPaths.includes(to.path) && !authPaths.includes(from.path) && to.fullPath !== from.fullPath) {
    return
  }
}) 